import React from 'react'

interface RootErrorFallbackProps {
  error: unknown
  componentStack: string
  eventId: string
  resetError: () => void
}

/**
 * Root-level error fallback displayed when the entire app crashes.
 * Uses inline styles only since MUI theme may not be available.
 */
export function RootErrorFallback({
  error,
  eventId,
  resetError,
}: RootErrorFallbackProps) {
  const errorMessage = error instanceof Error ? error.message : 'Unknown error'
  const errorStack = error instanceof Error ? error.stack : undefined

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '2rem',
        fontFamily: 'Roboto, Arial, sans-serif',
      }}
    >
      <div
        style={{
          maxWidth: 500,
          padding: '2rem',
          border: '1px solid #d32f2f',
          borderRadius: 8,
          backgroundColor: '#fff5f5',
        }}
      >
        <h1 style={{ color: '#d32f2f', margin: '0 0 1rem' }}>
          Application Error
        </h1>
        <p style={{ color: '#333', margin: '0 0 1rem' }}>
          Something went wrong and the application could not recover. The team
          has been notified.
        </p>
        {errorStack && (
          <pre
            style={{
              fontSize: '0.75rem',
              overflow: 'auto',
              maxHeight: 200,
              background: '#f5f5f5',
              padding: '0.5rem',
              borderRadius: 4,
              marginBottom: '1rem',
            }}
          >
            {errorMessage}
            {'\n'}
            {errorStack}
          </pre>
        )}
        {eventId && (
          <p style={{ fontSize: '0.875rem', color: '#666' }}>
            Error ID: {eventId}
          </p>
        )}
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button
            onClick={resetError}
            style={{
              padding: '8px 16px',
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: 4,
              cursor: 'pointer',
              fontFamily: 'Roboto, Arial, sans-serif',
            }}
          >
            Try Again
          </button>
          <button
            onClick={() => {
              window.location.href = '/'
            }}
            style={{
              padding: '8px 16px',
              backgroundColor: 'white',
              color: '#1976d2',
              border: '1px solid #1976d2',
              borderRadius: 4,
              cursor: 'pointer',
              fontFamily: 'Roboto, Arial, sans-serif',
            }}
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  )
}
